if (!window.BannerSlider) {
  document.addEventListener('DOMContentLoaded', function() {
    initSlideshows(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    const section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (section) initSlideshows(section);
  });

  function initSlideshows(root) {
    root.querySelectorAll('slideshow-component').forEach(el => {
      if (el.querySelector('.slider')) new BannerSlider(el);
    });
  }

  class BannerSlider {
    constructor(element) {
      this.slideshow = element;
      this.slider = this.slideshow.querySelector('.slider');
      this.dots = this.slideshow.querySelectorAll('.slider-counter__link');
      this.desktopSlides = this.slideshow.querySelectorAll('.desktop-slide');
      this.mobileSlides = this.slideshow.querySelectorAll('.mobile-slide');
      this.prevButton = this.slideshow.querySelector('.slider-button--prev');
      this.nextButton = this.slideshow.querySelector('.slider-button--next');
      this.autoPlaySpeed = parseInt(this.slider.dataset.speed) * 1000 || 5000;
      this.autoPlayTimer = null;
      this.currentIndex = 0;
      this.isAutoPlayEnabled = this.slider.dataset.pinflagAutoplay === 'true';
      this.isMobileView = this.isMobile();
      this.init();
    }

    init() {
      this.stopHiddenVideos();
      this.bindEvents();
      this.updateSlider();
      this.forceControlsVisible();
      if (this.isAutoPlayEnabled && this.getSlides().length > 1) {
        this.waitForFirstVideoThenAutoPlay();
      }
    }

    waitForFirstVideoThenAutoPlay() {
      const slides = this.getSlides();
      const firstSlide = slides[this.currentIndex];
      if (!firstSlide) { this.startAutoPlay(); return; }

      const video = firstSlide.querySelector('video');
      if (!video) { this.startAutoPlay(); return; }

      if (!video.paused) { this.startAutoPlay(); return; }

      const fallbackTimer = setTimeout(() => this.startAutoPlay(), 8000);
      video.addEventListener('playing', () => {
        clearTimeout(fallbackTimer);
        this.startAutoPlay();
      }, { once: true });
    }

    stopHiddenVideos() {
      const hidden = this.isMobile() ? this.desktopSlides : this.mobileSlides;
      hidden.forEach(slide => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (!video.paused) video.pause();
        video.preload = 'none';
      });
    }

    forceControlsVisible() {
      const controls = this.slideshow.querySelectorAll('.slideshow__controls, .slideshow__controls--top');
      if (!controls.length) return;

      const show = () => controls.forEach(c => {
        if (c.hasAttribute('hidden')) c.removeAttribute('hidden');
      });

      show();
      setTimeout(show, 300);

      const observer = new MutationObserver(show);
      controls.forEach(c => observer.observe(c, { attributes: true, attributeFilter: ['hidden'] }));
    }

    bindEvents() {
      this._resizeHandler = this.handleResize.bind(this);
      window.addEventListener('resize', this._resizeHandler);
      this.slider.addEventListener('scroll', this.updateActiveDot.bind(this));
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', e => {
          e.preventDefault();
          this.scrollToSlide(index);
          this.restartAutoPlay();
        });
      });
      if (this.prevButton) {
        this.prevButton.addEventListener('click', this.goToPrevSlide.bind(this));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.goToNextSlide.bind(this));
      }
    }

    handleResize() {
      const wasMobile = this.isMobileView;
      this.isMobileView = this.isMobile();

      if (wasMobile !== this.isMobileView) {
        requestAnimationFrame(() => {
          this.stopHiddenVideos();
          this.updateSlider();
          this.restartAutoPlay();
        });
      }
    }

    isMobile() {
      return window.innerWidth < 750;
    }

    getSlides() {
      return this.isMobile() ? this.mobileSlides : this.desktopSlides;
    }

    updateSlider() {
      this.scrollToSlide(this.currentIndex, false);
      this.updateActiveDot();
    }

    scrollToSlide(index, smooth = true) {
      const slides = this.getSlides();
      if (index >= slides.length) index = 0;
      if (index < 0) index = slides.length - 1;

      const prevIndex = this.currentIndex;
      this.currentIndex = index;

      if (prevIndex !== index) {
        this.pauseSlideVideo(prevIndex);
      }

      const slide = slides[index];
      if (slide) {
        this.slider.scrollTo({
          left: slide.offsetLeft,
          behavior: smooth ? 'smooth' : 'auto'
        });
      }

      this.playSlideVideo(index);
    }

    pauseSlideVideo(index) {
      const slides = this.getSlides();
      const slide = slides[index];
      if (!slide) return;
      const video = slide.querySelector('video');
      if (!video) return;
      if (!video.paused) video.pause();
      video.preload = 'none';
    }

    playSlideVideo(index) {
      const slides = this.getSlides();
      const slide = slides[index];
      if (!slide) return;
      const video = slide.querySelector('video');
      if (!video || !video.paused) return;

      if (video.preload === 'none') {
        video.preload = 'auto';
        video.load();
        video.addEventListener('canplay', () => {
          if (video.paused) video.play().catch(() => {});
        }, { once: true });
        return;
      }

      if (video.readyState >= 3) {
        video.play().catch(() => {});
      } else {
        video.addEventListener('canplay', () => {
          if (video.paused) video.play().catch(() => {});
        }, { once: true });
      }
    }

    updateActiveDot() {
      const activeIndex = Math.round(this.slider.scrollLeft / this.slider.offsetWidth);
      this.dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add('slider-counter__link--active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('slider-counter__link--active');
          dot.removeAttribute('aria-current');
        }
      });
    }

    goToPrevSlide() {
      this.scrollToSlide(this.currentIndex - 1);
      this.restartAutoPlay();
    }

    goToNextSlide() {
      this.scrollToSlide(this.currentIndex + 1);
      this.restartAutoPlay();
    }

    autoPlay() {
      this.scrollToSlide(this.currentIndex + 1);
    }

    startAutoPlay() {
      if (this.getSlides().length <= 1) return;
      this.stopAutoPlay();
      this.autoPlayTimer = setInterval(() => this.autoPlay(), this.autoPlaySpeed);
    }

    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
      }
    }

    restartAutoPlay() {
      if (this.isAutoPlayEnabled && this.getSlides().length > 1) {
        this.stopAutoPlay();
        setTimeout(() => this.startAutoPlay(), 2000);
      }
    }
  }

  window.BannerSlider = BannerSlider;
}
